import ImageHeader from './ImageHeader'

export default ImageHeader
